import {
    LIST_FUNCTIONARY_TYPES,
    LIST_FUNCTIONARY_TYPES_SUCCESS,
    LIST_FUNCTIONARY_TYPES_ERROR
} from '../types';

//Cada reducer tiene su propio state
const initialState = {
    functionaryTypes: null,
    error: null,
    loading: false
}

export default function(state = initialState, action) {
    switch(action.type){
        case LIST_FUNCTIONARY_TYPES:
            return {
                ...state,
                loading: true
            }
        case LIST_FUNCTIONARY_TYPES_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        case LIST_FUNCTIONARY_TYPES_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                functionaryTypes: action.payload
            }
        default:
            return state;
    }
}